import React from 'react'

import * as service from 'service'
import constants from './../constants'

const useSeller = () => {
  const isConfiguredPaymentMethods = React.useCallback(async () => {
    const [responseTokenAccount, responsesPaymentMethod] = await Promise.all([
      service.recurrence.settings.get({
        settingId: constants.settings.YAPAY_TOKEN_ACCOUNT,
      }),
      Promise.all([
        service.recurrence.settings.get({
          settingId: constants.settings.BILLET_METHOD,
        }),
        service.recurrence.settings.get({
          settingId: constants.settings.CARD_METHOD,
        }),
        service.recurrence.settings.get({
          settingId: constants.settings.TRANSFER_METHOD,
        }),
        service.recurrence.settings.get({
          settingId: constants.settings.BALANCE_METHOD,
        }),
      ]),
    ])

    return (
      !!responseTokenAccount.data.setting.value ||
      responsesPaymentMethod.every(
        response => response.data.setting.value === 'yapay',
      )
    )
  }, [])

  return {
    isConfiguredPaymentMethods,
  }
}

export default useSeller
